<template>
  <div class="login-page">
    <Login />
  </div>
</template>

<script>
import { mapState } from "vuex";

import Login from "@/components/public/pages/login/Login";

export default {
  name: "LimeLoansLoginpage",

  components: { Login },

  metaInfo: {
    meta: [
      {
        name: "facebook-domain-verification",
        content: process.env.VUE_APP_FACEBOOK_DOMAIN_VERIFICATION,
      },
    ],
  },

  data() {
    return {};
  },

  computed: {
    ...mapState({ auth: "auth" }),
  },

  created() {
    if (this.auth.loggedIn) {
      this.$router.push({ name: "DashboardMyLoanPage" });
    }
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
